export const DIALING = 'DIALING' // Online
export const ONLINE = 'ONLINE' // Online
export const OFFLINE = 'OFFLINE' // Offline
export const PAUSED = 'PAUSED' // Pausado
export const RINGING = 'RINGING' // Pausado
export const ONTHEPHONE = 'ONTHEPHONE' // Pausado
